import { useState } from 'react';
import { ForgotPasswordMethod, IParsedOTPData } from 'src/shared/interface/forgot-password';
import { EmailForm } from '../components/EmailForm';
import { SMSForm } from '../components/SMSForm';
import { MethodSelection } from '../components/MethodSelection';
import { useVerifyStep } from '../steps/verifyStep';

interface IVerifyStepContainerProps {
  method: ForgotPasswordMethod;
  onMethodChange: (method: ForgotPasswordMethod) => void;
  onSuccess: (username: string, identifier: string, otpData: IParsedOTPData) => void;
  onBack: () => void;
}

export const VerifyStepContainer = ({
  method,
  onMethodChange,
  onSuccess,
  onBack,
}: IVerifyStepContainerProps) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');

  const { loading, handleVerify } = useVerifyStep({ onSuccess });

  const handleMethodChangeWithClear = (newMethod: ForgotPasswordMethod) => {
    setUsername('');
    setEmail('');
    setPhoneNumber('');
    onMethodChange(newMethod);
  };

  const handleEmailSubmit = () => {
    handleVerify(method, { username, email });
  };

  const handleSMSSubmit = () => {
    handleVerify(method, { phoneNumber });
  };

  return (
    <>
      <MethodSelection selectedMethod={method} onMethodChange={handleMethodChangeWithClear} />
      <div className='mt-6'>
        {method === ForgotPasswordMethod.EMAIL ? (
          <EmailForm
            username={username}
            email={email}
            loading={loading}
            onUsernameChange={setUsername}
            onEmailChange={setEmail}
            onSubmit={handleEmailSubmit}
            onBack={onBack}
          />
        ) : (
          <SMSForm
            phoneNumber={phoneNumber}
            loading={loading}
            onPhoneNumberChange={setPhoneNumber}
            onSubmit={handleSMSSubmit}
            onBack={onBack}
          />
        )}
      </div>
    </>
  );
};
